<template>
  <div ref="element" data-growing-textarea>
    <textarea
      :id="props.id"
      class="textarea"
      :name="props.name"
      :rows="props.rows"
      :value="props.value"
      :disabled="props.disabled"
      @input="(event) => onUpdate(event.target.value)"
      @change="(event) => emit('change', event.target.value)"
    >
    </textarea>
  </div>
</template>

<script setup>import { ref as _ref } from 'vue';

  import { onMounted } from "vue";

  const emit = defineEmits(["change"]);

  const element = _ref(null);

  const props = defineProps({
    id: { type: String, default: "" },
    name: { type: String, default: "" },
    rows: { type: Number, default: 1 },
    disabled: { type: Boolean, default: false },

    value: { type: String, required: true },
  });

  const onUpdate = (value) => (element.value.dataset.replicatedValue = value);

  onMounted(() => {
    onUpdate(props.value);
  });
</script>
